module.exports = __webpack_public_path__ + "static/vector-shape5-5e898e657e7332c9b61917d55962c452.png";